// Sidebar — navegação principal. Itens por role: vendedor vê subset; gerente/owner vê tudo.
// Os itens + RBAC vivem em navItems.ts (compartilhados com a BottomNav mobile).
import { NavLink } from 'react-router-dom';
import { useAppSelector } from '@/app/store/hooks';
import { ROUTES } from '@/app/router/paths';
import { selectRole, useLogout } from '@/features/auth';
import { selectUnreadConversationCount } from '@/features/notifications';
import { ChatIcon, LogoutIcon, SettingsIcon } from '@/components/icons';
import { cn } from '@/lib/utils/cn';
import { navItemsForRole } from './navItems';
import styles from './Sidebar.module.css';

export function Sidebar() {
  const role = useAppSelector(selectRole);
  const unreadCount = useAppSelector(selectUnreadConversationCount);
  const { logout, isLoading } = useLogout();

  const items = role ? navItemsForRole(role) : [];

  return (
    <aside className={styles.sidebar} aria-label="Navegação principal">
      <div className={styles.brand} aria-hidden="true">
        <ChatIcon size={22} />
      </div>
      <nav className={styles.nav}>
        <ul className={styles.list}>
          {items.map((item) => {
            // Badge de mensagens novas só na "Conversas" (rota do inbox).
            const badge = item.to === ROUTES.inbox && unreadCount > 0 ? unreadCount : 0;
            return (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => cn(styles.link, isActive && styles.active)}
                >
                  <span className={styles.iconWrap}>
                    <item.Icon size={20} />
                    {badge > 0 && (
                      <span
                        className={styles.badge}
                        aria-label={`${badge} conversa${badge > 1 ? 's' : ''} com mensagens novas`}
                      >
                        {badge > 99 ? '99+' : badge}
                      </span>
                    )}
                  </span>
                  <span className={styles.label}>{item.label}</span>
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className={styles.footer}>
        <NavLink
          to={ROUTES.config}
          className={({ isActive }) => cn(styles.footerBtn, isActive && styles.active)}
          aria-label="Ajustes"
        >
          <SettingsIcon size={18} />
          <span className={styles.label}>Ajustes</span>
        </NavLink>
        <button
          type="button"
          className={styles.logoutBtn}
          onClick={() => void logout()}
          disabled={isLoading}
          aria-label="Sair da conta"
        >
          <LogoutIcon size={18} />
          <span className={styles.label}>Sair</span>
        </button>
      </div>
    </aside>
  );
}
